import React from 'react';
import './TermsAndConditionsPage.css';
import Products2Hero from '../components/Products2Hero';

const TermsAndConditionsPage = () => {
  const termsMarquee = [
    'Fair Usage Policy',
    'Transparent Governance',
    'Certified Quality Standards',
    'Customer Agreement 2025',
    'Legal Compliance Standards',
    'Nexawave Service Terms'
  ];

  const sections = [
    { id: 'sec-1', num: '01', title: 'Introduction' },
    { id: 'sec-2', num: '02', title: 'General Use' },
    { id: 'sec-3', num: '03', title: 'Intellectual Property' },
    { id: 'sec-4', num: '04', title: 'Third-Party Links' },
    { id: 'sec-5', num: '05', title: 'Law & Jurisdiction' },
  ];

  return (
    <div className="terms-page">
      <Products2Hero 
        className="hero-tight"
        tagline="NEXAWAVE GOVERNANCE · LEGAL FRAMEWORK · SERVICE STANDARDS"
        title1="Terms & Conditions"
        title2=""
        title3=""
        description=""
        button1Text="Read Terms"
        button1Link="#terms-content"
        button2Text="Refund Policy"
        button2Link="/refund-policy"
        marqueeItems={termsMarquee}
      />

      <div id="terms-content" className="terms-content">
        {/* Sticky Sidebar Navigation */}
        <aside className="terms-sidebar">
          <h4 className="sidebar-title">Quick Navigation</h4>
          <ul className="sidebar-nav">
            {sections.map((s) => (
              <li key={s.id}>
                <a href={`#${s.id}`}>
                  <span className="sidebar-nav-num">{s.num}</span>
                  <span>{s.title}</span>
                </a>
              </li>
            ))}
          </ul>
        </aside>

        {/* Main Sections */}
        <div className="terms-sections">
          {/* Introduction */}
          <section id="sec-1" className="terms-section">
            <h2 className="section-title">Introduction</h2>
            <p className="section-text">
              For the purpose of these Terms and Conditions, The term "we", "us", "our" used anywhere on this page shall mean NEXAWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED, whose registered/operational office is H.No. 16-5-1/4, Farhat Nagar Hyderabad Hyderabad TELANGANA 500023. "you", "your", "user", "visitor" shall mean any natural or legal person who is visiting our website and/or agreed to purchase from us.
            </p>
          </section>

          {/* General Use */}
          <section id="sec-2" className="terms-section">
            <h2 className="section-title">General Usage Terms</h2>
            <p className="section-text">
              The content of the pages of this website is subject to change without notice. Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website for any particular purpose.
            </p>
            <p className="section-text">
              Your use of any information or materials on our website and/or product pages is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services or information available through our website meet your specific requirements.
            </p>
          </section>

          {/* Intellectual Property */}
          <section id="sec-3" className="terms-section">
            <h2 className="section-title">Intellectual Property</h2>
            <p className="section-text">
              Our website contains material which is owned by or licensed to us. This material includes, but are not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice.
            </p>
            <p className="section-text">
              Unauthorized use of information provided by us shall give rise to a claim for damages and/or be a criminal offense.
            </p>
          </section>

          {/* Third-Party Links */}
          <section id="sec-4" className="terms-section">
            <h2 className="section-title">Third-Party Links</h2>
            <p className="section-text">
              From time to time our website may also include links to other websites. These links are provided for your convenience to provide further information.
            </p>
            <p className="section-text">
              You may not create a link to our website from another website or document without NEXAWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED’s prior written consent.
            </p>
          </section>

          {/* Law & Jurisdiction */}
          <section id="sec-5" className="terms-section">
            <h2 className="section-title">Governing Law and Jurisdiction</h2>
            <p className="section-text">
              Any dispute arising out of use of our website and/or purchase with us and/or any engagement with us is subject to the laws of India.
            </p>
            <p className="section-text">
              We shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any Transaction, on Account of the Cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time.
            </p>
            <div className="disclaimer-box">
              <p>
                <strong>Disclaimer:</strong> The above content is created at NEXAWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED's sole discretion. Razorpay shall not be liable for any content provided here and shall not be responsible for any claims that may arise due to merchant’s non-adherence to it.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;
